import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    FAVICON: {
        URI: () => '/api/v1/buyboxes/{{id}}/landing-page-favicon',
        methods: ['delete'],
        default: {},
    },
    LOGO: {
        URI: () => '/api/v1/buyboxes/{{id}}/landing-page-logo',
        methods: ['delete'],
        default: {},
    },
    SPACES_LANDING_PAGE: {
        URI: () => '/api/v1/spaces/{{id}}/landing-page',
        methods: ['get', 'patch'],
        default: {},
        cacheToClear: ['/api/v1/publishers/\\d+/buybox-landing-pages'],
    },
    LANDING_PAGE: {
        URI: () => '/api/v1/buyboxes/{{id}}/landing-page',
        methods: ['get', 'patch'],
        default: {},
    },
    IMAGES: {
        URI: () => '/api/v1/buyboxes/{{id}}/landing-page-images',
        methods: ['post'],
        default: {},
    },
    SPACES_IMAGES: {
        URI: () => '/api/v1/spaces/{{id}}/landing-page-images',
        methods: ['post'],
        default: {},
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
